import { Link } from "react-router-dom";
import { useState } from "react";
import "./footer.css";
import {
  right_arrow, facebook,
  instagram,
  linkedIn,
  youtube,
  dental_image
} from "../../../assets/images/images";

const HomeFooter = () => {
  const [showInstagramDropdown, setShowInstagramDropdown] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const toggleInstagramDropdown = () => {
    setShowInstagramDropdown(!showInstagramDropdown);
  };

  const closeInstagramDropdown = () => {
    setShowInstagramDropdown(false);
  };

  return (
    <>
      <footer className="footer-section">
        <div className="container">
          <div className="footer-section-main">
            <div className="row">
              {/* Quick Links Section */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="footer-column">
                  <h4 className="footer-title">Quick Links</h4>
                  <div className="footer-links-grid">
                    <div className="links-column">
                      <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>Home</a>
                      <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a>
                      <a href="#doctors" onClick={(e) => { e.preventDefault(); scrollToSection('doctors'); }}>About Us</a>
                    </div>
                    <div className="links-column">
                      <a href="#awards" onClick={(e) => { e.preventDefault(); scrollToSection('awards'); }}>Why Choose Us</a>
                      <a href="#testimonials" onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); }}>Testimonials</a>
                      <a href="#gallery" onClick={(e) => { e.preventDefault(); scrollToSection('gallery'); }}>Gallery</a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact & Social Section */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="footer-column">
                  <h4 className="footer-title">Contact Info</h4>
                  <div className="contact-compact">
                    <p className="address">1st Floor, Garli Heritage, Ajmera Main Rd, opp. to Bank of Maharashtra, Masulkar Colony, main, Pimpri Colony, Pune, Pimpri-Chinchwad, Maharashtra 411018</p>
                    <a href="#location" onClick={(e) => { e.preventDefault(); scrollToSection('location'); }} className="map-link">
                      View on Maps
                    </a>
                  </div>
                </div>
              </div>

              {/* Social Media Section */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="footer-column">
                  <h4 className="footer-title">Connect With Us</h4>
                  <div className="social-section">
                    <div className="social-icons">
                      <div className="instagram-dropdown-container">
                        <div 
                          className="social-link instagram-btn" 
                          onClick={toggleInstagramDropdown}
                          onBlur={closeInstagramDropdown}
                        >
                          <img src={linkedIn} alt="Instagram" />
                        </div>
                        {showInstagramDropdown && (
                          <div className="instagram-dropdown">
                            <a 
                              href="https://www.instagram.com/shree_vishwangad_ayurved?igsh=MXJtcW1ycnlwbHpsZw==" 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="dropdown-item"
                              onClick={(e) => {
                                console.log('Ayurveda link clicked');
                                window.open('https://www.instagram.com/shree_vishwangad_ayurved?igsh=MXJtcW1ycnlwbHpsZw==', '_blank');
                                setShowInstagramDropdown(false);
                              }}
                            >
                              <span className="dropdown-icon">🌿</span>
                              <span className="dropdown-text">Ayurveda Clinic</span>
                            </a>
                            <a 
                              href="https://www.instagram.com/shirkande_dentalclinic?igsh=NHpwcHRpbTJvNjdj" 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="dropdown-item"
                              onClick={(e) => {
                                console.log('Dental link clicked');
                                window.open('https://www.instagram.com/shirkande_dentalclinic?igsh=NHpwcHRpbTJvNjdj', '_blank');
                                setShowInstagramDropdown(false);
                              }}
                            >
                              <span className="dropdown-icon">🦷</span>
                              <span className="dropdown-text">Dental Clinic</span>
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Doctor Contacts Section - Full Width */}
            <div className="row">
              <div className="col-12">
                <div className="doctor-contacts-section">
                  <h4 className="footer-title">Contact Our Doctors</h4>
                  <div className="doctor-contacts-grid">
                    <div className="doctor-contact">
                      <span className="doctor-name">Dr. Abhijeet Shirkande</span>
                      <span className="doctor-phone">+91 99752 53664</span>
                    </div>
                    <div className="doctor-contact">
                      <span className="doctor-name">Dr. Ankita Shirkande</span>
                      <span className="doctor-phone">+91 97665 88108</span>
                    </div>
                    <div className="doctor-contact">
                      <span className="doctor-name">Dr. Sapana Shirkande</span>
                      <span className="doctor-phone">+91 88502 06371</span>
                    </div>
                    <div className="doctor-contact">
                      <span className="doctor-name">Dr. Amol Shirkande</span>
                      <span className="doctor-phone">+91 80875 95712</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default HomeFooter;
